<ng-container *transloco="let t; read: 'inbox-dial-phone-button'">
  <p-toast position="bottom-center"></p-toast>
  <p-button
    [disabled]="!canDial || dialInProgress"
    label="{{ t(dialButtonCell.translationKey, dialButtonCell.translationObj) }}"
    [loading]="dialInProgress"
    (onClick)="doDialClick()"
  >
  </p-button>
</ng-container>
